import { useElementShown } from '@hh.ru/analytics-js';
import resumeAddSkillButtonClick from '@hh.ru/analytics-js-events/build/career_platform/profession/resume_add_skill_button_click';
import resumeAddSkillElementShown from '@hh.ru/analytics-js-events/build/career_platform/profession/resume_add_skill_element_shown';
import { translation, TranslatedComponent } from '@hh.ru/front-static-app';
import {
    ActionBar,
    BottomSheet,
    BottomSheetFooter,
    Button,
    Modal,
    Text,
    Title,
    useBreakpoint,
} from '@hh.ru/magritte-ui';

import { useCalculatorContext } from 'src/pages/Profession/components/SectionCalculator/Context';

import styles from './styles.less';

const LinkKeys = {
    profile: 'https://hh.ru/applicant/resumes',
};

const TrlKeys = {
    title: 'career-platform.profession.sections.calculator.add-skills-to-resume.title',
    text: 'career-platform.profession.sections.calculator.add-skills-to-resume.text',
    button: 'career-platform.profession.sections.calculator.add-skills-to-resume.button',
    close: 'career-platform.profession.sections.calculator.add-skills-to-resume.close',
};

const CalculatorFillSkillsDialog: TranslatedComponent = ({ trls }) => {
    const {
        professionId,
        modalFillSkills: { isOpen, onClose },
    } = useCalculatorContext();

    const { isXS, isS } = useBreakpoint();
    const isMobile = isXS || isS;

    const ref = useElementShown(resumeAddSkillElementShown, { professionId });

    const handleAddSkill = () => {
        onClose();
        resumeAddSkillButtonClick({ professionId });
    };

    const Content = (
        <div ref={ref} className={styles.content}>
            {isMobile && (
                <Title size="medium" Element="h3">
                    {trls[TrlKeys.title]}
                </Title>
            )}
            <Text typography="paragraph-1-regular" Element="p">
                {trls[TrlKeys.text]}
            </Text>
        </div>
    );

    const CloseButton = (
        <Button
            mode={isMobile ? 'secondary' : 'tertiary'}
            onClick={onClose}
            stretched={isMobile}
            size={isMobile ? 'large' : 'medium'}
        >
            {trls[TrlKeys.close]}
        </Button>
    );

    const AddSkillsButton = (
        <Button
            mode="primary"
            onClick={handleAddSkill}
            stretched={isMobile}
            size={isMobile ? 'large' : 'medium'}
            Element="a"
            href={LinkKeys.profile}
            target="_blank"
            rel="noreferrer noopener nofollow"
        >
            {trls[TrlKeys.button]}
        </Button>
    );

    if (isMobile) {
        return (
            <BottomSheet
                visible={isOpen}
                onClose={onClose}
                footer={
                    <BottomSheetFooter>
                        {AddSkillsButton}
                        {CloseButton}
                    </BottomSheetFooter>
                }
            >
                {Content}
            </BottomSheet>
        );
    }

    return (
        <Modal
            visible={isOpen}
            onClose={onClose}
            title={trls[TrlKeys.title]}
            footer={<ActionBar secondaryActions={CloseButton} primaryActions={AddSkillsButton} />}
        >
            {Content}
        </Modal>
    );
};

export default translation(CalculatorFillSkillsDialog);
